export const classNames = (...classes: any) => classes.filter(Boolean).join(" ");